import { Components, Theme } from '@mui/material/styles';

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    root: {
      color: 'var(--palette-text-primary)',
    },
  },
};
